import {
  type ReactElement,
  type ReactNode,
  createContext,
  createElement,
  useContext,
  useState,
} from 'react';

export interface SearchContextType {
  keyword: string;
  setKeyword: (payload: string) => void;
  clearKeyword: () => void;
}

export interface SearchProps {
  children: ReactNode;
}

export const SearchContext = createContext<SearchContextType | null>(null);

export function SearchProvider({ children }: SearchProps): ReactElement {
  const [keyword, setKeyword] = useState<string>('');
  function setSearchKeyword(payload: string) {
    setKeyword(payload);
  }

  function clearKeyword() {
    setKeyword('');
  }

  return createElement(
    SearchContext.Provider,
    {
      value: {
        keyword,
        clearKeyword,
        setKeyword: setSearchKeyword,
      },
    },
    children
  );
}

export function useSearch() {
  const search = useContext(SearchContext) as SearchContextType;
  return search;
}
